// src/components/sections/Home/Caracteristicas/Caracteristicas.jsx
import React, { useMemo } from "react";
import "./caracteristicas.css";
import Loader from "../../elements/Loader/Loader";
import useStore from "../../../useStore";

const Características = () => {
  // Solo leemos del store, no disparamos fetch aquí
  const homes = useStore(state => state.homes);
  const loading = useStore(state => state.loading);
  const error = useStore(state => state.error);

  // Derivamos posts UNA VEZ de homes
  const posts = useMemo(() => {
    if (!Array.isArray(homes) || homes.length === 0) return [];
    return homes.flatMap(item => item.caracteristicasComponent || []);
  }, [homes]);

  // Si está cargando, mostramos Loader
  if (loading) return <Loader />;
  // Si hubo error o no hay posts, nada
  if (error || posts.length === 0) return null;

  const strapiBase = process.env.REACT_APP_STRAPI_API_BASE.replace("/api", "");

  return (
    <div className="container caracteristicas-container">
      <div className="row">
        {posts.map(item => {
          const fullImageUrl = `${strapiBase}${item.imagen?.url || ""}`;
          return (
            <div className="col-md-4 caracteristica" key={item.id}>
              <div
                className="caracteristica-icon"
                style={{ backgroundImage: `url(${fullImageUrl})` }}
              />
              <h2 className="caracteristica-title">{item.titulo}</h2>
              <p className="caracteristica-description">
                {item.descripcion}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Características;
